import React from 'react'
import { Box, Button, Link, ListItem, Row, Stack, Text, UnorderedList } from 'src/ui'

type NewStoneXIntegrationGuideProps = Readonly<{
  onCancel: () => void
  onShowWebhookConfiguration: () => void
  onNext: () => void
}>

export default function NewStoneXIntegrationGuide({
  onCancel,
  onShowWebhookConfiguration,
  onNext,
}: NewStoneXIntegrationGuideProps) {
  return (
    <Box py={2} mb={4} borderRadius={3} bg="white" boxShadow="md">
      <Box px={6} py={5} borderBottomWidth="1px">
        <Text fontSize="18px">StoneX</Text>
      </Box>

      <Stack px={6} py={5} spacing={5}>
        <Box>
          <Text fontWeight="bold" mb={2}>
            Required StoneX credentials
          </Text>
          <Text>
            The following credentials must be requested from StoneX and securely communicated back
            to Bushel:
          </Text>
          <UnorderedList mt={2} spacing={1}>
            <ListItem>
              Service key with the following permissions: "Delayed Cash Bids and Futures with
              Basis", "View All Offers", and "View Producers".
            </ListItem>
            <ListItem>Merchant ID</ListItem>
            <ListItem>Impersonation key</ListItem>
          </UnorderedList>
        </Box>

        <Box>
          <Text fontWeight="bold" mb={2}>
            Include webhook configuration in the request
          </Text>
          <Text mb={2}>
            StoneX must setup a webhook connection in their system to send data back to Bushel. Use{' '}
            <Link href="https://ss.bushelops.com" isExternal color="blue.600">
              ss.bushelops.com
            </Link>{' '}
            to securely share the webhook URL and secret with StoneX. Ask StoneX to:
          </Text>
          <UnorderedList spacing={2}>
            <ListItem>
              Place the webhook secret in an Authorization &quot;Custom Header&quot;.
            </ListItem>
            <ListItem>Configure maximum retries to a value of 20.</ListItem>
          </UnorderedList>
          <Button colorScheme="secondary" onClick={onShowWebhookConfiguration} size="sm">
            Show Webhook Configuration
          </Button>
        </Box>

        <Row justifyContent="flex-end" gap={2}>
          <Button colorScheme="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button colorScheme="primary" onClick={onNext}>
            Next
          </Button>
        </Row>
      </Stack>
    </Box>
  )
}
